import {MediabankResource} from "../mediabank/types";
import {Media, MediatableAttribute} from "../drafts/types";
import {OwnershipAttribute} from "../creations/types";

export interface GetResourcesMetaDataResponse {
    id: string;
    name: string;
    voohItems: ResourceMetaData[]
}


export type ResourceMetaData = Pick<MediabankResource, 'id' | 'byteSize' | 'byteSizeHumanized' | 'tagList'> & {categoryColor: string, categoryName: string, categoryId:number | null, duration: number, itemType: VoohItemType, mediabankResourceId: number, position: number, editableDuration: boolean, voohItemType: VoohItemType, resourceName?: string, bufor: boolean};

export interface VoohCategory {
    id: number
    name: string;
    color: string;
}

export enum VoohItemType {
    Advertisement = "advertisement",
    MediabankResource = "mediabank_resource",
    Bumper = "bumper",
}

export type VoohPlaylistType = 'internal' | 'external';

export interface VoohForm {
    id: null | number;
    name: string;
    mediaFormat: string | undefined;
    tagList: string[];
    startAt: string;
    endAt: string;
    voohItemsAttributes: VoohItem[];
    localisablesMediatablesAttributes: MediatableAttribute[];
    ownershipsAttributes: OwnershipAttribute[];
    nominalDuration: number;
    defaultPlaylist: boolean;
    photographic: boolean;
    replanning: boolean;
    playlistType: VoohPlaylistType;
}

export type VoohDetails = Pick<VoohForm, 'id' | 'name' | 'mediaFormat' | 'tagList' | 'startAt' | 'endAt' | 'nominalDuration' | 'defaultPlaylist' | 'photographic' | 'replanning' | 'playlistType'> & {voohItems: ResourceMetaData[]; media: Media[]; ownerships: OwnershipAttribute[]; voohPlaylistStatus: string};

export type VoohListItem = Pick<VoohForm, 'name' | 'mediaFormat' |'tagList' | 'startAt' | 'endAt' | 'defaultPlaylist' | 'photographic' | 'playlistType' > & { id: number, voohPlaylistStatus: string };



export interface VoohItem {
    id?: number | null;
    mediabankResourceId?: number;
    tagList?: string[];
    position: number;
    duration: number;
    itemType: VoohItemType;
    categoryId: number | null;
    bufor?: boolean;
    _destroy?: boolean;
}

export type ScheduleRow = Partial<ResourceMetaData> & {name?: string, uuid: string, voohItemType: VoohItemType, duration: number, categoryId: number| null, _destroy?: boolean, tagList?: string[];};


interface MediaTemplateBase {
    id: number,
    name: string,
}

export interface MediaTemplate extends MediaTemplateBase {
    media: number[]
}

export interface MediaTemplateResponse extends MediaTemplateBase {
    media: {id: number}[]
}

export interface MediaTemplatePayload {
    name: string;
    localisablesMediatablesAttributes: MediatableAttribute[];
}

export interface VoohListsFilteringMeta {
    filtering: {
        fields: {
            mediaFormatIn: {
                allowedValues: string[]
            }
            nameCont: {
                allowedValues: string
            }
            tagsNameIn: {
                allowedValues: string[]
            }
            voohPlaylistStatusEq: {
                allowedValues: string[]
            }
        }
    }
    order: {
        by: string[]
        dir: string[]
    }
}

export interface VoohPlayListsFilters {
    page: number;
    nameCont: string;
    mediaFormatIn: string[];
    tagsNameIn: string[];
    voohPlaylistStatusEq: string[] | string;
    startAtLteq: string;
    endAtGteq: string;
    s: string;
}

export interface VoohGap {
    [date: string]: number[]
}

export interface VoohGapTemplate {
    title: string;
    media: number[];
}